import React from "react";

interface ProgressBarProps {
  current: number;
  total: number;
}
const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const rawPercentage = (current / total) * 100;
  const percentage =
    rawPercentage % 1 === 0 ? rawPercentage : rawPercentage.toFixed(2);

  const containerStyle: React.CSSProperties = {
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
    padding: "10px",
  };

  const progressInfoStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "5px",
    fontSize: "14px",
  };

  const progressBarStyle: React.CSSProperties = {
    width: "100%",
    backgroundColor: "#e0e0e0",
    borderRadius: "5px",
    overflow: "hidden",
  };

  const progressBarFillStyle: React.CSSProperties = {
    height: "20px",
    backgroundColor: "#4caf50",
    textAlign: "center",
    lineHeight: "20px", // Center text vertically
    color: "white",
    fontSize: "14px",
    width: `${percentage}%`,
  };
  return (
    <div style={containerStyle}>
      <div style={progressInfoStyle}>
        <span>
          {current} / {total}
        </span>
        {/* <span>{Math.round(percentage)}%</span> */}
      </div>
      <div style={progressBarStyle}>
        <div style={progressBarFillStyle}>{percentage}%</div>
      </div>
    </div>
  );
};

export default ProgressBar;
